<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Selecione a lactação</p>
    <v-autocomplete
      @update:search-input="searchAnimal"
      item-text="title"
      item-value="id"
      :items="animals"
      outlined
      dense
      label="Selecione o Animal"
      v-model="filter.animal"
      no-data-text="Nenhum Resultado"
      clearable
      class="form-panel__field form-panel__field--wide"
    ></v-autocomplete>

    <v-autocomplete
      :items="animalsBirth"
      item-text="date"
      item-value="id"
      outlined
      dense
      label="Selecione o Parto do animal"
      return-object
      v-model="filter.birth"
      no-data-text="Nenhum Resultado"
      clearable
      class="form-panel__field"
    ></v-autocomplete>

    <div class="form-panel__toggles">
      <div class="d-flex align-items-center">
        <v-switch
          inset
          hide-details
          v-model="filter.manager"
          color="var(--jersey-yellow)"
        ></v-switch>
      
        <p class="m-0">Gerencial</p>
      </div>

      <div class="d-flex align-items-center">
        <v-switch
          inset
          hide-details
          v-model="filter.official"
          color="var(--jersey-yellow)"
        ></v-switch>
      
        <p class="m-0">Oficial</p>
      </div>
    </div>

    <div class="form-panel__actions">
      <v-btn 
        class="success" 
        @click="submit"
      >
        <i class="mdi mdi-chart-timeline-variant pr-1"></i>
        Extrato
      </v-btn>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
export default {
  name: "ReportFilters",
  data: () => ({
    keyInput: 0,
    filter: {
      official: false,
      manager: true
    },
    animals:[]
  }),
  computed: {
    ...mapState("animals", [
      "animalsBirth"
    ])
  },
  methods: {
    ...mapActions("animals", [
      "actionSearchAnimalsGeneral",
      "actionGetAnimalsBirth"
    ]),
    async searchAnimal(data) {
      if(data && data.length > 2 && !this.filter.animal || this.filter.animal && data && data.length > 1) {
        const results = await this.actionSearchAnimalsGeneral({register:data});
        if(results.length)
          this.animals = results.map(e => ({...e, title: e.code + ' - ' + e.register + ' - ' + e.name}));
      }
    },
    async getBirths() {
      if(this.filter.animal) {
        await this.actionGetAnimalsBirth({animal_id: this.animals.find(e => e.id === this.filter.animal).id});
      }
    },
    submit() {
      if(!this.filter.animal || !this.filter.birth) {
        this.$toast.error("Selecione o animal e o parto para consultar o extrato !");
      } else {
        this.$emit("submit-report", {
          ...this.filter,
          option: this.filter.official,
          animal_data: this.animals.find(animal => animal.id === this.filter.animal)
        });
        if(this.filter.manager) this.$emit("show-solids");
         else this.$emit("hide-solids");
      }

    }
  },
  watch: {
    "filter.manager": {
      handler(val) {
        if(val === true) {
          this.filter.official = false;
          if(this.filter.animal && this.filter.birth) {
            this.submit();
          }
        }
      }
    },
    "filter.official": {
      handler(val) {
        if(val === true) {
          this.filter.manager = false;
          if(this.filter.animal && this.filter.birth) {
            this.submit();
          }
        }
      }
    },
    "filter.animal": {
      async handler() {
        await this.getBirths();
      }
    }
  }
}
</script>

<style>
</style>
